var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 50.483,
    viewBox: "0 0 48 50.483",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "player-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_139",
    "data-name": "Rectangle 139",
    width: 31.698,
    height: 42.37,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_307",
    "data-name": "Groupe 307",
    transform: "translate(-101 -39.517)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15",
    "data-name": "Ellipse 15",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(101 42)",
    fill: "#39003c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_271",
    "data-name": "Groupe 271",
    transform: "translate(109.151 39.517)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1158",
    "data-name": "Trac\\xE9 1158",
    d: "M10.749,0,4.857,3.324,2.53,9.428,3.4,17.349l-1.994.315L0,20.565l1.741,4.253,2.522,1.13,1.922-1.076L8.047,30.9l8.947,4.015,5.345.342,5.816-1.711,3.311-6.819-.592-3.857.824-7.98-.392-3.854-.432-4.385L30,3.666,20.832,0Z",
    fill: "#ffc5c0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_270",
    "data-name": "Groupe 270",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_269",
    "data-name": "Groupe 269",
    clipPath: "url(#player-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1159",
    "data-name": "Trac\\xE9 1159",
    d: "M13.13,87.254s1.109-.277,1.07-2.02-2.3-3.174-2.812-2.637,1.7,1.272,1.584,2.271-.99,2.663.158,2.386",
    transform: "translate(-8.78 -64.031)",
    fill: "#330434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1160",
    "data-name": "Trac\\xE9 1160",
    d: "M34.493,130.11l3.431,4.7,12.733,3.351.8,3.323-4.971,1.893L38.84,141.5l-4.361-2.415,0-6.085Z",
    transform: "translate(-26.766 -101.004)",
    fill: "#ffc5c0"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1178",
    "data-name": "Trac\\xE9 1178",
    d: "M7.4,26.208H3.26a8.618,8.618,0,0,1,.475-2.774A4.047,4.047,0,0,1,4.64,22q.51-.476.95-.908A1.465,1.465,0,0,0,6.029,20a.828.828,0,0,0-.526-.863,4.393,4.393,0,0,0-1.516-.2,5.078,5.078,0,0,0-1.521.26,6.681,6.681,0,0,0-1.4.6V15.315A15.9,15.9,0,0,1,3.305,14.6a10.092,10.092,0,0,1,2.269-.241,9.36,9.36,0,0,1,2.527.362,4.755,4.755,0,0,1,2.224,1.352,3.792,3.792,0,0,1,.93,2.7,4.414,4.414,0,0,1-.49,2.19,9.362,9.362,0,0,1-1.486,1.885,12.509,12.509,0,0,0-1.435,1.676A2.963,2.963,0,0,0,7.4,26.208Zm-4.326,1.9H7.586V33H3.078Z",
    transform: "translate(17.153 -7.517)",
    fill: "#f37e72"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.3749badf5b1667cf98bbc920d8ad5c4a.svg";
export { ForwardRef as ReactComponent };